import { Skeleton } from "@mui/material";
import { UserSettingsSkeletonSectionContainer } from "components/Preferences/UserSettings/UserSettingsSkeleton.styles.ts";
import { PersonSettingsHeaderText } from "components/Preferences/text.ts";

const PersonSettingsSkeleton = () => {
	return (
		<UserSettingsSkeletonSectionContainer>
			<div>{PersonSettingsHeaderText}</div>
			<Skeleton
				variant="text"
				width="100%"
				height="300px"
			/>
		</UserSettingsSkeletonSectionContainer>
	);
};

export default PersonSettingsSkeleton;
